import { User, Role } from './user.model';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UserGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) { }

  static canActivateWithRole(router: Router, state: RouterStateSnapshot, user$: Observable<User>, role: Role) {
    return user$.pipe(
      take(1),
      map(user => user && user.hasRole(role)),
      tap(hasRole => {
        if (!hasRole) {
          console.error("Access denied - " + role + " only");
          router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        }
      })
    );
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.auth.user$.pipe(
      take(1),
      map(user => user ? true : false),
      tap(isUser => {
        if (!isUser) {
          console.error("Access denied - User only");
          this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        }
      })
    );
  }

}
